
const TalentAppCard = ({ children, className }) => {
    return (
        <div className={`talent-app-card overflow-hidden rounded-xl border border-gray-300 bg-white ${className}`}>
            {children}
        </div>
    )
}

const TalentAppCardSection = ({ children, className }) => {
    return (
        <section className={`talent-app-card-section border-t border-gray-300 px-5 py-6 first-of-type:border-t-0 sm:px-10 sm:py-8 ${className}`}>
            {children}
        </section>
    )
}

TalentAppCard.Section = TalentAppCardSection;

export { TalentAppCard }

// USAGE

// <TalentAppCard>
//     <TalentAppCard.Section>
//         section 1 information
//     </TalentAppCard.Section>
//     <TalentAppCard.Section>
//         section 2 information
//     </TalentAppCard.Section>
// </TalentAppCard>
